module.exports = __webpack_public_path__ + "static/media/icon-download-blue.66f6c01f.svg";